module.exports = __webpack_public_path__ + "img/play.3a561275.png";